/**
 * TypeScript type definitions for Google reCAPTCHA v3
 */

declare global {
  interface Window {
    grecaptcha?: {
      ready: (callback: () => void) => void;
      execute: (
        siteKey: string,
        options: { action: string }
      ) => Promise<string>;
      enterprise?: {
        ready: (callback: () => void) => void;
        execute: (
          siteKey: string,
          options: { action: string }
        ) => Promise<string>;
      };
    };
  }
}

/**
 * reCAPTCHA action types for different operations
 */
export type RecaptchaAction =
  | 'agent_session_create'
  | 'agent_message_send'
  | 'agent_feedback_submit'
  | 'feedback' // New action for Beehive feedback
  | 'login'
  | 'submit';

/**
 * reCAPTCHA token response
 */
export interface RecaptchaTokenResponse {
  token: string;
  action: RecaptchaAction;
  timestamp: number;
}

/**
 * reCAPTCHA error types
 */
export class RecaptchaError extends Error {
  constructor(
    message: string,
    public code: RecaptchaErrorCode,
    public originalError?: Error
  ) {
    super(message);
    this.name = 'RecaptchaError';
  }
}

export enum RecaptchaErrorCode {
  NOT_LOADED = 'RECAPTCHA_NOT_LOADED',
  EXECUTION_FAILED = 'RECAPTCHA_EXECUTION_FAILED',
  TIMEOUT = 'RECAPTCHA_TIMEOUT',
  NOT_CONFIGURED = 'RECAPTCHA_NOT_CONFIGURED',
}
